import { Skeleton } from '@/components/ui/skeleton';
import classes from './classes';
export const DatasetSidebarSkeleton = () => <div className="px-4 md:p-0 flex flex-col w-full md:w-4/12 gap-5 md:gap-10 shrink-0">
    <div className="space-y-2">
      <h5 className={classes.heading}>Source</h5>
      <div className="space-y-2 mt-4">
        <Skeleton className="h-4 w-[250px] bg-secondary-readable/[0.25]" />
        <Skeleton className="h-4 w-[200px] bg-secondary-readable/[0.25]" />
      </div>
    </div>
    <div className="space-y-2">
      <h5 className={classes.heading}>Description</h5>

      <div className="space-y-2 mt-4">
        <Skeleton className="h-4 w-[250px] bg-secondary-readable/[0.25]" />
        <Skeleton className="h-4 w-[200px] bg-secondary-readable/[0.25]" />
      </div>
    </div>
    <div className="space-y-2">
      <h5 className={classes.heading}>Keywords</h5>

      <div className="space-y-2 mt-4">
        <Skeleton className="h-4 w-[250px] bg-secondary-readable/[0.25]" />
        <Skeleton className="h-4 w-[200px] bg-secondary-readable/[0.25]" />
      </div>
    </div>
    <div className="flex flex-col gap-5">
      <h5 className={classes.heading}>Tables</h5>

      <div className="flex flex-col gap-3">
        <Skeleton className="rounded-none h-20 w-full bg-secondary" />
        <Skeleton className="rounded-none shadow-lg h-20 w-full bg-[#acc2ff47]" />
        <Skeleton className="rounded-none shadow-lg h-20 w-full bg-[#acc2ff47]" />
        <Skeleton className="rounded-none shadow-lg h-20 w-full bg-[#acc2ff47]" />
        <Skeleton className="rounded-none shadow-lg h-20 w-full bg-[#acc2ff47]" />
        <Skeleton className="rounded-none shadow-lg h-20 w-full bg-[#acc2ff47]" />
      </div>
    </div>
  </div>;